import { names } from 'utilities/constants';

const videoConstants = names('DEVICE_CHANGED', 'MIRROR_CHANGED');
export default videoConstants;